import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CustomDateRangePicker from '../../../../shared-components/custom-date-range/CustomDateRangePicker';
import TabToggle, { TabItem } from '../../../../shared-components/tab-toggle/TabToggle';
// import HealthFaultAnalytics from '../location-reports/HealthFaultAnalytics';
import PowerConsumptionReportChart from '../location-reports/PowerConsumptionReportChart';
import ReportsSummary from '../location-reports/ReportsSummary';
import RevenueReportChart from '../location-reports/RevenueReportChart';
import UtilizationEfficiencyReport from '../location-reports/UtilizationEfficiencyReport';

/**
 * Station Reports
 * @returns {React.JSX.Element} The rendered component
 */
function LocationReports() {
  const { t, i18n } = useTranslation('sidePanel');
  const [selectedTab, setSelectedTab] = useState<string>('summary');

  const [dateRange, setDateRange] = useState<{ startDate: string; endDate: string }>({
    startDate: '',
    endDate: '',
  });

  const tabItems: TabItem[] = useMemo(
    () => [
      { label: t('summary'), value: 'summary' },
      { label: t('revenueAndEnergyTrends'), value: 'revenueAndEnergyTrends' },
      { label: t('utilizationAndEfficiency'), value: 'utilizationAndEfficiency' },
    ],
    [t],
  );

  return (
    <div dir={i18n.dir()}>
      <div className="reports-tab-toggle-wrap">
        <TabToggle
          tabs={tabItems}
          isLabelValue
          activeTab={selectedTab}
          defaultTab="summary"
          onChange={(tab) => setSelectedTab(tab)}
        />
        {selectedTab === 'revenueAndEnergyTrends' && (
          <div className="reports-date-picker">
            <CustomDateRangePicker
              startDate={dateRange.startDate}
              endDate={dateRange.endDate}
              onChange={(start, end) => setDateRange({ startDate: start, endDate: end })}
              placeholder="DD-MMM-YYYY - DD-MMM-YYYY"
              defaultPreset="last14Days"
            />
          </div>
        )}
      </div>
      {selectedTab === 'summary' && (
        <div>
          <ReportsSummary />
        </div>
      )}
      {selectedTab === 'revenueAndEnergyTrends' && (
        <div className="revenue-energy-trends">
          <PowerConsumptionReportChart
            startDate={dateRange.startDate}
            endDate={dateRange.endDate}
          />
          <RevenueReportChart startDate={dateRange.startDate} endDate={dateRange.endDate} />
        </div>
      )}
      {selectedTab === 'utilizationAndEfficiency' && (
        <div>
          <UtilizationEfficiencyReport />
        </div>
      )}
      {selectedTab === 'healthAndFaultAnalytics' && <div>{/* <HealthFaultAnalytics /> */}</div>}
    </div>
  );
}

export default LocationReports;
